@if (openWidget()) {
  <p-dialog
    [(visible)]="openWidget"
    [draggable]="true"
    [resizable]="false"
    [modal]="false"
    [style]="widgetStyle()"
    maskStyleClass="remove-modal-mask"
    position="top"
    styleClass="chat-widget-dialog"
    contentStyleClass="overflow-hidden"
    [appendTo]="appendTo()"
  >
    <ng-template #header>
      <div class="row w-full justify-between">
        <div class="row">
          <new-ui-button
            [severity]="expandedView() ? 'warn' : 'secondary'"
            [icon]="PrimeIcons.DESKTOP"
            (onClick)="expandedView.set(true)"
          ></new-ui-button>

          <new-ui-button
            [severity]="!expandedView() ? 'warn' : 'secondary'"
            [icon]="PrimeIcons.TABLET"
            (onClick)="expandedView.set(false)"
          ></new-ui-button>

          <new-ui-button
            severity="secondary"
            [icon]="PrimeIcons.WINDOW_MAXIMIZE"
            (onClick)="openWidgetInNewWindow()"
          ></new-ui-button>
        </div>

        <div></div>
      </div>
    </ng-template>

    @if (newUiChatWidgetComponent()) {
      <ng-container
        *ngComponentOutlet="
          newUiChatWidgetComponent();
          inputs: { preSelectionContext: contextForPreSelection(), mobileView: !expandedView() }
        "
      >
      </ng-container>
    }
  </p-dialog>
}
